<div style="height: 87vh; overflow-x: auto;">

  <!-- Top bar: status stat cards (click to filter) + actions -->
  <div class="top-bar-row">
    <div class="stat-cards">
      @for (card of StatCards; track card.label) {
      <div class="summary-card {{ card.cssClass }}"
           [class.active]="ActiveStatusFilter === card.statusId"
           (click)="selectStatusCard(card)">
        <div class="summary-label">{{ card.label }}</div>
        <div class="summary-value">{{ Counts?.[card.countKey] ?? 0 }}</div>
      </div>
      }
    </div>

    <div class="action-buttons-row">
      <label class="mine-toggle">
        <input type="checkbox" [checked]="MineOnly" (change)="toggleMineOnly()" />
        Only mine
      </label>
      <button class="btn-bg-green" (click)="openNewSwap()">+ New Swap</button>
    </div>
  </div>

  <!-- rms-table needs columns ready before it renders -->
  @if (Loaded) {
  <rms-table [HeaderButtons]="Buttons"
             [parentContext]="this"
             [data]="FilteredRows"
             [columns]="Columns"
             tableId="swap-management-main"
             [customizable]="true"
             startSort="SwapNumber"
             startSortDirection="desc">
  </rms-table>
  } @else {
  <div class="loading">Loading...</div>
  }

</div>
